import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { BudgetLine } from '../../lib/types/models/budget-line/budget-line'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getAllocatedBudgets(input: PaginationRequest<null, string, Version, null> = {}) {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.budgetAllocation.getAll.url, null), input))
    .get<PaginationResponse<BudgetLine>>()
}
